function LogoIcon({ color = "#E53D51", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 224 144" {...props}>
      <g fill={color}>
        <path d="M72,72c0-39.76,32.23-71.99,71.99-71.99s71.99,32.23,71.99,71.99s-32.23,71.99-71.99,71.99S72,111.76,72,72" />
        <path d="M72.06,143.99c-39.76,0-71.99-32.23-71.99-71.99S32.3,0.01,72.06,0.01" />
      </g>
    </svg>
  );
}

export default LogoIcon;
